import { useRoutes } from 'react-router-dom';

// project-imports
import MainLayout from '../layout/MainLayout';
import Dashboard from '../pages/Dashboard';
import TenantList from '../pages/tenants/TenantList';
import CreateTenant from '../pages/tenants/CreateTenant';
import TenantDetails from '../pages/tenants/TenantDetails';
import RoleManagement from '../pages/roles/RoleManagement';
import PermissionMatrix from '../pages/roles/PermissionMatrix';
import UserManagement from '../pages/users/UserManagement';
import UserRoleAssignment from '../pages/users/UserRoleAssignment';
import RoleAnalytics from '../pages/roles/RoleAnalytics';
import AuditLogs from '../pages/audit/AuditLogs';
import Profile from '../pages/profile/Profile';
import Login from '../pages/auth/Login';
import ForgotPassword from '../pages/auth/ForgotPassword';
import VerifyOtp from '../pages/auth/VerifyOtp';
import ResetPassword from '../pages/auth/ResetPassword';
import ProtectedRoute from '../components/auth/ProtectedRoute';

// Subscription pages
import PlanList from '../pages/subscriptions/PlanList';
import PlanEdit from '../pages/subscriptions/PlanEdit';
import OrgPlanAssignment from '../pages/subscriptions/OrgPlanAssignment';
import AuditTrail from '../pages/subscriptions/AuditTrail';

// Demo page
import DemoManagement from '../pages/demo/DemoManagement';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  return useRoutes([
    {
      path: '/login',
      element: <Login />
    },
    {
      path: '/forgot-password',
      element: <ForgotPassword />
    },
    {
      path: '/verify-otp',
      element: <VerifyOtp />
    },
    {
      path: '/reset-password',
      element: <ResetPassword />
    },
    {
      path: '/',
      element: (
        <ProtectedRoute>
          <MainLayout />
        </ProtectedRoute>
      ),
      children: [
        {
          path: '',
          element: <Dashboard />
        },
        {
          path: 'dashboard',
          element: <Dashboard />
        },
        {
          path: '/tenants',
          element: <TenantList />
        },
        {
          path: '/tenants/create',
          element: <CreateTenant />
        },
        {
          path: '/tenants/:id',
          element: <TenantDetails />
        },
        {
          path: '/users',
          element: <UserManagement />
        },
        {
          path: '/users/roles',
          element: <UserRoleAssignment />
        },
        {
          path: '/roles',
          element: <RoleManagement />
        },
        {
          path: '/roles/permissions',
          element: <PermissionMatrix />
        },
        {
          path: '/roles/analytics',
          element: <RoleAnalytics />
        },
        {
          path: '/audit-logs',
          element: <AuditLogs />
        },
        {
          path: '/demo',
          element: <DemoManagement />
        },
        {
          path: '/profile',
          element: <Profile />
        },
        {
          path: '/subscriptions/plans',
          element: <PlanList />
        },
        {
          path: '/subscriptions/plans/new',
          element: <PlanEdit />
        },
        {
          path: '/subscriptions/plans/edit/:planId',
          element: <PlanEdit />
        },
        {
          path: '/subscriptions/assignments',
          element: <OrgPlanAssignment />
        },
        {
          path: '/subscriptions/audit',
          element: <AuditTrail />
        }
      ]
    }
  ]);
}